import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { AppSettings } from 'app/modules/shared/app.settings';
import { CommonBindingDataService } from 'app/modules/shared/services/common-binding-data.service';
import { StorageService } from 'app/modules/shared/services/storage.service';
import { ManageOpenShiftsService } from '../../services/manage-open-shifts.service';
import { UiService } from 'app/modules/shared/services/ui.service';
import * as moment from 'moment';
import { LoaderService } from 'app/modules/shared/components/loader/loader.service';

@Component({
  selector: 'app-add-time-off-modal',
  templateUrl: './add-time-off-modal.component.html',
  styleUrls: ['./add-time-off-modal.component.scss']
})
export class AddTimeOffModalComponent implements OnInit {
  @Output() closeAddTimeOffEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Input() addTimeOffDetails: any;
  timeOffForm: any;
  minDate = new Date();
  dateFormat: any;
  leaveTypeList: any[] = [];
  isDisableBtn = false;
  isFullDayLeave = false;
  availableEndTime: Date;
  availableStartTime: Date;
  minuteArray: number[] = [0, 15, 30, 45];
  currentDate = new Date();
  formattedDate: any;
  formattedEndDate: any;
  isStartDateGraterthenEndDate = false;
  minEndDate: Date;
  maxEndDate: Date;
  constructor(private formBuilder: FormBuilder,
    private commonService: CommonBindingDataService,
    private storageService: StorageService,
    private manageOpenShiftsService: ManageOpenShiftsService,
    private commonBindingDataService: CommonBindingDataService,
    private uiService: UiService,
    private loaderService: LoaderService) { }

  ngOnInit(): void {
    this.dateFormat = this.commonService.getDateFormat();
    const tagsData = this.storageService.getItem(AppSettings.TAG_DATA);
    if (tagsData == null) {
      const localTagData = localStorage.getItem('localTagdata');
      this.setDropdownValues(JSON.parse(localTagData));
    } else {
      this.setDropdownValues(tagsData);
      localStorage.removeItem('localTagdata');
    }
    this.createTimeOffForm();
    this.timeOffForm.controls['startDate'].setValue(this.addTimeOffDetails?.date);
    this.minEndDate = new Date(this.addTimeOffDetails?.date);
    this.maxEndDate = new Date(this.minEndDate);
    this.maxEndDate.setFullYear(this.maxEndDate.getFullYear() + 1);
    this.currentDate = this.commonBindingDataService.addOneHourToCurrentTime();
  }

  createTimeOffForm() {
    this.timeOffForm = this.formBuilder.group({
      startTimeStr: ['',
      Validators.required,
    ],
      endTimeStr: ['',
        Validators.required,
      ],
      leaveTypeId: [this.leaveTypeList[0].value],
      startDate: [this.addTimeOffDetails?.date, [
        Validators.required,
      ]],
      endDate: ['', [Validators.required]],
      fullDayOff: [false],
      notes: ['', []],
    });
  }


  setDropdownValues(tagsData) {
    tagsData.leave_type.forEach(element => {
      this.leaveTypeList.push({ label: element.tagValue, value: element.tagId });
    });
  }

  addTimeOff() {
    this.loaderService.show('');
    this.isDisableBtn = true;
    const memberDetails = {
      userId: this.addTimeOffDetails?.userId,
      providerId: this.addTimeOffDetails?.providerId ,
      teamId: this.addTimeOffDetails?.teamId
    };
    this.timeOffForm.controls['notes'].setValue(this.timeOffForm.value.notes.trim());
    const memberLeaveDetails = {...this.timeOffForm.value, ...memberDetails };
    if (memberLeaveDetails.endDate !== (null || '')) {
      if (new Date(memberLeaveDetails.endDate) >= new Date(memberLeaveDetails.startDate)) {
        memberLeaveDetails.endDate = moment(new Date(memberLeaveDetails.endDate)).format('MM/DD/YYYY');
        memberLeaveDetails.startDate = moment(new Date(memberLeaveDetails.startDate)).format('MM/DD/YYYY');
        this.applyLeave(memberLeaveDetails);
      } else {
        this.uiService.showMessage('End date should be greater than Start date.', AppSettings.MESSAGE_TYPES.ERROR);
        this.timeOffForm.controls['endDate'].setValue(null);
        this.isDisableBtn = false;
      }
    }
  }

    applyLeave(data) {
    if (!this.isFullDayLeave) {
    const startTimeStr =  moment(this.timeOffForm.value.startTimeStr).format('hh:mm A');
    const endTimeStr = moment(this.timeOffForm.value.endTimeStr).format('hh:mm A');

    data.startTimeStr = startTimeStr;
    data.endTimeStr = endTimeStr;
    } else {
      data.startTimeStr = '12:00 AM';
      data.endTimeStr = '11:59 PM';
    }
    this.manageOpenShiftsService.applyLeave(data).subscribe((res) => {
      this.loaderService.hide();
      this.uiService.showMessage(res.general[0].message, AppSettings.MESSAGE_TYPES.SUCCESS);
      this.closeAddTimeOffEmitter.emit(true);
    }, (error) => {
      this.isDisableBtn = false;
      this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPES.ERROR);
    });
  }

  cancel() {
    this.closeAddTimeOffEmitter.emit(false);
  }

  changeDate(date) {
    this.formattedDate = date.toLocaleDateString();
    this.timeOffForm.controls['startDate'].setValue(this.formattedDate);
    this.minEndDate = new Date(date);
    // this.maxEndDate = new Date(this.minEndDate.getTime() + (30 * 24 * 3600000));
    this.maxEndDate = new Date(this.minEndDate);
    this.maxEndDate.setFullYear(this.maxEndDate.getFullYear() + 1);
    this.changeEndDate(this.timeOffForm.controls['endDate'].value);
  }

  changeEndDate(endDate) {
    if (endDate !== ('' || null)) {
      this.formattedEndDate = endDate;
    }
    if (this.formattedEndDate !== (null || '')) {
      if (new Date(this.formattedEndDate) >= new Date(this.timeOffForm.controls['startDate'].value)) {
        this.timeOffForm.controls['endDate'].setValue(this.formattedEndDate);
      } else {
        this.uiService.showMessage('End date should be greater than Start date.', AppSettings.MESSAGE_TYPES.ERROR);
        this.timeOffForm.controls['endDate'].setValue(null);
      }
    }
  }

  enableFullDayLeave(isFullDayLeave) {
    this.isFullDayLeave = isFullDayLeave;
    if (isFullDayLeave) {
        this.timeOffForm.get('startTimeStr').clearValidators();
        this.timeOffForm.get('startTimeStr').updateValueAndValidity();
        this.timeOffForm.get('startTimeStr').setValue('');
        this.timeOffForm.get('endTimeStr').clearValidators();
        this.timeOffForm.get('endTimeStr').updateValueAndValidity();
        this.timeOffForm.get('endTimeStr').setValue('');
      } else {
        this.timeOffForm.get('startTimeStr').setValidators([Validators.required]);
        this.timeOffForm.get('startTimeStr').updateValueAndValidity();
        this.timeOffForm.get('endTimeStr').setValidators([Validators.required]);
        this.timeOffForm.get('endTimeStr').updateValueAndValidity();
      }
  }
  getTime(event: any) {
    if (this.timeOffForm.controls.startTimeStr.value !== '') {
      const hour = moment(this.timeOffForm.controls.startTimeStr.value).format('hh:mm A').split(':');
      const time = this.commonBindingDataService.timeAdjustment(hour);
      this.availableStartTime = new Date(`1970-01-01 ${time}`);
      // this.timeOffForm.controls.startTimeStr.setValue(this.availableStartTime);
    }
  }

  getEndTime(event: any) {
    if (this.timeOffForm.controls.endTimeStr.value !== '') {
      const hour1 = moment(this.timeOffForm.controls.endTimeStr.value).format('hh:mm A');
      const hour = moment(this.timeOffForm.controls.endTimeStr.value).format('hh:mm A').split(':');
      if (hour1 !== '11:59 PM') {
        const time = this.commonBindingDataService.timeAdjustment(hour);
        this.availableEndTime = new Date(`1970-01-01 ${time}`);
       // this.timeOffForm.controls.endTimeStr.setValue(this.availableEndTime);
      }
      // setTimeout(() => {
      //   this.startTimeValue();
      // }, 500);
    }
  }
}
